import React from "react"
import { Container } from "reactstrap"
import awicon from "../../../assets/images/services-icon/coin.png"

type HeaderProp = {
  title: React.ReactElement | string | undefined;
  subjectId?: number;
  activityTypeName: string;
  coinsEarned?: number;
  coinsPossible?: number;
}

export const Header =
  (props: HeaderProp) => {

    const { title, subjectId, activityTypeName } = props

    let subjectName = ""
    switch (subjectId) {
      case 1:
        subjectName = "English"
      case 2:
        subjectName = "Mathematics"
    }

    return (
      <Container className="custom-wt">
        <div className="d-flex align-items-center">
          <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
            <div
              className="text-white font-size-14 text-uppercase"
              onClick={() => history.back()}
            >
              {" "}
              <span><i className=" fas fa-chevron-left me-1"></i></span>
              {" "}
              Back
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between flex-grow-1">
            <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
              {title}
            </h6>
            <p className="mb-0 text-uppercase luminous-wht">
              {" "}
              <span className="text-yellow me-1">
              {subjectName}
            </span>{" "}
              {activityTypeName}
              {" "}
            </p>

            <div className="luminous-wht font-size-16">
              <img width={24} className="" src={awicon} alt="" /> {props.coinsEarned ?? 0}/{props.coinsPossible ?? 0}{" "}
              coins
            </div>

            {/*<div className="luminous-wht font-size-16">*/}
            {/*  <img width={24} className="" src={awicon} alt="" />{" "}*/}
            {/*  {ActivityData && ActivityData.coins_earned*/}
            {/*    ? ActivityData.coins_earned*/}
            {/*    : 0}*/}
            {/*  /*/}
            {/*  {ActivityData &&*/}
            {/*  ActivityData.LessonActivitiesQuestions &&*/}
            {/*  ActivityData.LessonActivitiesQuestions.length > 0*/}
            {/*    ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)*/}
            {/*    : 0}{" "}*/}
            {/*  coins*/}
            {/*</div>*/}
          </div>
        </div>
      </Container>

    )
  }
